module.exports = __webpack_public_path__ + "img/talk-img4.07dcb9d2.png";